/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import {PrivateWhiteboardService} from '@app/modules/whiteboard/services/private-whiteboard.service';
import {WhiteboardCommands} from '@app/models/commands/whiteboard-commands';
import {GeoGebraService} from '@app/modules/whiteboard/services/geo-gebra.service';

@Injectable({
  providedIn: 'root'
})
export class PrivateWhiteboardCommands extends WhiteboardCommands {

  static category = 'PRIVATE_WHITEBOARD';

  constructor(protected whiteboardService: PrivateWhiteboardService, store: Store) {
    super(whiteboardService, store);
  }
}
